var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 25
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "search_svg__a",
    d: "M10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "search_svg__b",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    fill: "#fff",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#search_svg__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#D5DEDA",
    strokeDasharray: "0,0",
    transform: "translate(.85)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#search_svg__a",
    strokeWidth: 4,
    mask: "url(#search_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "m17.02 17.08 7.07 7.07"
  }))));
};

export default SvgSearch;